import clsx from 'clsx'

import { AppIcon } from 'shared/ui/app-icon'
import { AllIcons } from 'shared/ui/app-icon/types'

import s from './styles.module.scss'

interface MyOrderStatusProps {
  title?: string
  color?: string
  background?: string
  showInfoIcon?: boolean
  onClick?: () => void
}

export const MyOrderStatus = ({
  title,
  color,
  background,
  showInfoIcon = false,
  onClick,
}: MyOrderStatusProps) => {
  const handleClick = showInfoIcon ? onClick : undefined

  return (
    <div
      className={s.statusButton}
      onClick={handleClick}
    >
      {showInfoIcon && (
        <div
          className={clsx(s.statusIconWrapper)}
          style={{ backgroundColor: background }}
        >
          <AppIcon
            id={AllIcons.INFO_CIRCLE}
            width={14}
            height={14}
            className={s.statusIcon}
            color={color}
          />
        </div>
      )}

      <div
        className={clsx(s.statusBadge)}
        style={{ color: color, backgroundColor: background }}
      >
        <span className="semi-bold-12">{title}</span>
      </div>
    </div>
  )
}
